<template>
  <div>
    <v-autocomplete :value="value" :items="languages" item-text="name" item-value="languageId" v-bind="$attrs"
                    v-on="$listeners"
    />
  </div>
</template>

<script>

export default {
  name: 'LanguageSelect',
  inheritAttrs: false,
  props: {
    value: { type: String, default: '' },
  },
  computed: {
    languages() { return this.$store.getters.languages; },

  },
  mounted() {
    this.$store.dispatch('loadLanguages');
  },

};
</script>
